<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 md3 lg3>
                        <v-text-field
                          v-model="filter.dataId"
                          :label="label.dataId"
                          :error-messages="errors.collect('filter.dataId')"
                          data-vv-name="filter.dataId"
                          :data-vv-as="label.dataId"
                          v-validate="'max:10'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3 lg3 v-if="filterTab == 'Sanction Details'">
                        <v-text-field
                          v-model="filter.fullName"
                          :label="label.fullName"
                          :error-messages="errors.collect('filter.fullName')"
                          data-vv-name="filter.fullName"
                          :data-vv-as="label.fullName"
                          v-validate="'max:240'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3 lg3 v-if="filterTab == 'Alias Details'">
                        <v-text-field
                          v-model="filter.aliasName"
                          :label="label.aliasName"
                          :error-messages="errors.collect('filter.aliasName')"
                          data-vv-name="filter.aliasName"
                          :data-vv-as="label.aliasName"
                          v-validate="'max:240'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3 lg3 v-if="filterTab == 'Sanction Details'">
                        <v-text-field
                          v-model="filter.docNo"
                          :label="label.docNo"
                          :error-messages="errors.collect('filter.docNo')"
                          data-vv-name="filter.docNo"
                          :data-vv-as="label.docNo"
                          v-validate="'max:40'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-5"></v-spacer>
    <v-layout>
        <v-flex xs12>
          <v-card>
            <v-tabs v-model="tabs">
              <v-tab v-for="(detailTab, x) in detailTabs" :key="x" @click="doColumn(detailTab)">{{
                detailTab
              }}</v-tab>
              <v-spacer></v-spacer>
            </v-tabs>
            <v-tabs-items v-model="tabs" touchless>
              <v-tab-item :key="1">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="headers1"
                      v-bind:items="items"
                      :server-items-length="totalItems"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="pagination"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in sanctionColumns" :key="column">{{ row.item[column] }}</td>
                        <td class="table-action-header">
                          <table-action :rowData="row" query @query="doQuery(row.item)"></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="2">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                    :headers="headers2"
                    :items="items"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :server-items-length="totalItems"
                    v-bind:options.sync="pagination"
                    item-key="name"
                    :loading="loading"
                    :no-data-text="noDataText"
                  >
                  <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in aliasColumns" :key="column">{{ row.item[column] }}</td>
                        <td class="table-action-header">
                          <table-action :rowData="row" query @query="doQuery(row.item)"></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-flex>
      </v-layout>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { formatDisplayDate, formatDisplayDateTime4 } from '@/utils/date'

export default {
  data() {
    return {
      headers1: [
        { text: 'Data Id', value: 'dataId' },
        { text: 'Full Name', value: 'fullName' },
        { text: 'Generated Date', value: 'genDate' },
        { text: 'List Date', value: 'listDate' },
        { text: 'List Type', value: 'unListType' },
        TableConst.tableActionHeader
      ],
      headers2: [
        { text: 'Data Id', value: 'dataId' },
        { text: 'Alias Name', value: 'aliasName' },
        { text: 'Alias Quality', value: 'aliasQuality' },
        { text: 'Generated Date', value: 'dateGen' },
        TableConst.tableActionHeader
      ],
      label: {
        dataId: 'Data Id',
        fullName: 'Full Name',
        aliasName: 'Alias Name',
        docNo: 'Document No.'
      },
      columns: [],
      sanctionColumns: ['dataId', 'fullName', 'genDate', 'listDate', 'unListType'],
      aliasColumns: ['dataId', 'aliasName', 'aliasQuality', 'dateGen'],
      filter: {
        dataId: null,
        fullName: null,
        aliasName: null,
        docNo: null
      },
      tab: undefined,
      tabs: undefined,
      filterTab: 'Sanction Details',
      detailTabs: ['Sanction Details', 'Alias Details'],
      toogleArray: [],
      totalItems: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      let apiURI = this.$store.state.underwriting.dataTransferSettings.menu
      if (this.filterTab === 'Sanction Details') {
        apiURI = this.$store.state.underwriting.dataTransferSettings.menu.sanctionList
      } else if (this.filterTab === 'Alias Details') {
        apiURI = this.$store.state.underwriting.dataTransferSettings.menu.aliasList
      }
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: false
          }
          let messageFilters = clone(this.filter)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((sanction) => {
                const convertList = {
                  dataId: sanction.dataId,
                  genDate: formatDisplayDateTime4(sanction.genDate),
                  name1: sanction.name1,
                  name2: sanction.name2,
                  name3: sanction.name3,
                  name4: sanction.name4,
                  fullName: sanction.fullName,
                  aliasName: sanction.aliasName,
                  aliasQuality: sanction.aliasQuality,
                  dateGen: formatDisplayDateTime4(sanction.dateGen),
                  unListType: sanction.unListType,
                  refNo: sanction.refNo,
                  listDate: formatDisplayDate(sanction.listDate),
                  deListDate: formatDisplayDate(sanction.deListDate),
                  gender: sanction.gender,
                  comment: sanction.comment,
                  dob: formatDisplayDate(sanction.dob),
                  docNo: sanction.docNo,
                  quality: sanction.quality,
                  createdByFirstName: sanction.createdByFirstName,
                  createdDate: formatDisplayDate(sanction.createdDate),
                  modifiedByFirstName: sanction.modifiedByFirstName,
                  modifiedDate: formatDisplayDate(sanction.modifiedDate)
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          if (err.response) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      }
    },
    doColumn(detailTab) {
      this.filterTab = undefined
      this.filter.dataId = null
      this.filter.fullName = null
      this.filter.aliasName = null
      this.filter.docNo = null
      this.pagination.page = 1
      if (detailTab === 'Sanction Details') {
        this.tab = 'Sanction Details'
        this.filterTab = 'Sanction Details'
        this.columns = Object.assign(this.columns)
        this.columns.push(
          { text: 'Data Id', value: 'dataId' },
          { text: 'Full Name', value: 'fullName' },
          { text: 'Generated Date', value: 'genDate' },
          { text: 'List Date', value: 'listDate' },
          { text: 'List Type', value: 'unListType' }
        )
      } else if (detailTab === 'Alias Details') {
        this.tab = 'Alias Details'
        this.filterTab = 'Alias Details'
        this.columns = Object.assign(this.columns)
        this.columns.push(
          { text: 'Data Id', value: 'dataId' },
          { text: 'Alias Name', value: 'aliasName' },
          { text: 'Alias Quality', value: 'aliasQuality' },
          { text: 'Generated Date', value: 'dateGen' }
        )
      }
      this.doInit()
    },
    doClearFilters() {
      this.filter.dataId = null
      this.filter.fullName = null
      this.filter.aliasName = null
      this.filter.docNo = null
      this.tab = 0
      this.pagination.page = 1
      this.doInit()
    },
    doFilters() {
      this.tab = 0
      this.pagination.page = 1
      this.doInit()
    },
    doQuery(data) {
      if (data) {
        this.$router.push({
          name: 'querySanction',
          params: {
            sanction: data
          }
        })
      }
    }
  },
  watch: {
    tabs: function(value) {
      if (value === 0) {
        this.doColumn('Sanction Details', this.columns)
      }
    },
    'pagination': function (value) {
      this.doInit()
    },
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
